const saveUserSettingOnLocalStorage = (id, settings) => {
    localStorage.setItem(`user.settings.${id}`, JSON.stringify(settings));
};

export default saveUserSettingOnLocalStorage;
